import Axios from 'axios';
import { getEndpointURL } from './config';

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const ValidateUserInfo = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/validate-user-info`
    })
}

const Register = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/register`
    })
}

const Signin = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/signin`
    })
}

const AuthCaptcha = (captcha) => {
    return Axios({
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        data: { captcha },
        url: `${endpointURL}/api/auth/auth-captcha/`
    })
}

const AuthToken = async () => {
    return Axios({
        method: 'GET',
        headers,
        url: `${endpointURL}/api/auth/auth-token/`
    })
}

const VerifyEmail = async (token) => {
    return Axios({
        method: 'GET',
        headers,
        url: `${endpointURL}/api/auth/verify-email/` + token
    })
}

const Signout = () => {
    localStorage.removeItem('_grecaptcha');
    localStorage.removeItem('_userinfor');
    return Axios({
        method: 'POST',
        headers,
        data: {},
        url: `${endpointURL}/api/auth/sign-out`
    })
}

const ForgotPassword = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/forgot-password`
    })
}

const AuthResetPasswordToken = async (token) => {
    return Axios({
        method: 'GET',
        headers,
        url: `${endpointURL}/api/auth/auth-reset-password-token/` + token
    })
}

const ResetPassword = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/reset-password/`
    })
}

const SendMessage = async (message) => {
    return Axios({
        method: 'POST',
        headers,
        data: message,
        url: `${endpointURL}/api/auth/send-message/`
    })
}

const ChangeLanguage = (locale) => {
    return Axios({
        method: 'POST',
        headers,
        data: { locale },
        url: `${endpointURL}/api/auth/change-language/`
    })
}

const TranslateContents = (contents) => {
    return Axios({
        method: 'GET',
        headers,
        params: contents,
        url: `${endpointURL}/api/auth/translate-contents`
    })
}

const VnpayCreatePaymentUrl = (paymentInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: paymentInfor,
        url: `${endpointURL}/api/payments/vnpay/vnpay-create-payment-url`
    })
}

const VnpayReturnUrl = (vnp_Params) => {
    return Axios({
        method: 'GET',
        headers,
        params: vnp_Params,
        url: `${endpointURL}/api/payments/vnpay/vnpay-return-url`
    })
}

export {
    ValidateUserInfo,
    Register,
    Signin,
    AuthCaptcha,
    AuthToken,
    VerifyEmail,
    Signout,
    ForgotPassword,
    AuthResetPasswordToken,
    ResetPassword,
    SendMessage,
    ChangeLanguage,
    TranslateContents,
    VnpayCreatePaymentUrl,
    VnpayReturnUrl,
};
